export enum SortableOrder {
    Unsorted="unsorted",
    Ascending="asc",
    Descending="desc"
}